<template>
  <div class="form-content">
    <div class="quick-create-btn">
      <el-popover placement="right" width="200" trigger="click">
        <el-select
          v-model="task_id"
          filterable
          clearable
          placeholder="请选择关联任务"
          @change="selectTask"
        >
          <el-option
            v-for="item in taskList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button slot="reference" type="primary" size="mini">
          快速创建
        </el-button>
      </el-popover>
    </div>
    <el-form
      ref="companyForm"
      :inline="true"
      :model="formData"
      label-width="130px"
    >
      <el-col v-for="(item, index) in formList" :key="index" :span="12">
        <el-form-item
          :label="item.label"
          :prop="item.props"
          :rules="[
            {
              required: item.required,
              message: '请输入' + item.label,
              trigger: 'blur',
            },
          ]"
        >
          <template v-if="item.type == 'input'">
            <el-input
              v-model="formData[item.props]"
              class="input"
              :placeholder="item.placeholder"
            ></el-input>
          </template>
          <template v-else-if="item.type == 'textarea'">
            <el-input
              v-model="formData[item.props]"
              class="input"
              type="textarea"
            ></el-input>
          </template>
          <template v-else-if="item.type == 'picker'">
            <el-select
              v-model="formData[item.props]"
              class="select"
              :placeholder="item.placeholder || '请选择'"
              :disabled="item.disabled || (item.props === 'is_sync_alipay' && !!id)"
              clearable
              filterable
            >
              <el-option
                v-for="(item1, index1) in item.selectOption"
                :key="index1"
                :label="item1.label"
                :value="item1.value"
              ></el-option>
            </el-select>
          </template>
          <template v-else-if="item.type == 'multiplePicker'">
            <div
              :class="[
                'multiple-picker-wrap',
                {
                  'multiple-picker-wrap--with-action':
                    item.props === 'mission_ids' && showCreateTaskAction,
                },
              ]"
            >
              <el-select
                v-model="formData[item.props]"
                class="select"
                :placeholder="item.placeholder || '请选择'"
                clearable
                filterable
                multiple
                :collapse-tags="item.collapseTags || false"
                :max-collapse-tags="
                  item.maxCollapseTags != null ? item.maxCollapseTags : undefined
                "
              >
                <el-option
                  v-for="(item1, index1) in item.selectOption"
                  :key="index1"
                  :label="item1.label"
                  :value="item1.value"
                ></el-option>
              </el-select>
              <el-button
                v-if="item.props === 'mission_ids' && showCreateTaskAction"
                class="mission-create-btn"
                type="primary"
                size="medium"
                @click="openCreateTaskDialog"
              >
                新建任务
              </el-button>
            </div>
          </template>
          <template v-else-if="item.type == 'cascader'">
            <el-cascader
              v-model="formData[item.props]"
              class="cascader"
              :placeholder="item.placeholder || '请选择'"
              clearable
              filterable
              :checkStrictly="true"
              :show-all-levels="false"
              :props="{ multiple: item.multiple }"
              :options="item.selectOption"
              :collapse-tags="item.collapseTags || false"
              :max-collapse-tags="
                item.maxCollapseTags != null ? item.maxCollapseTags : undefined
              "
            />
          </template>
          <template v-else-if="item.type == 'salary'">
            <div style="width: 260px">
              <el-col :span="10">
                <el-input
                  v-model="formData.min_salary"
                  class="salary-input"
                  placeholder="最低薪资"
                />
              </el-col>
              <el-col :span="2" class="text-center">
                <span class="text-gray-500">-</span>
              </el-col>
              <el-col :span="10">
                <el-input
                  v-model="formData.max_salary"
                  class="salary-input"
                  placeholder="最高薪资"
                />
              </el-col>
              <el-col :span="2">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="如若填写相同薪资，则展示固定薪资"
                  placement="right"
                >
                  <i class="el-icon-warning"></i>
                </el-tooltip>
              </el-col>
            </div>
          </template>
          <template v-else-if="item.type == 'age'">
            <div style="width: 260px">
              <el-col :span="10">
                <el-input
                  v-model="formData.min_age"
                  class="salary-input"
                  placeholder="最小年龄"
                />
              </el-col>
              <el-col :span="2" class="text-center">
                <span class="text-gray-500">-</span>
              </el-col>
              <el-col :span="10">
                <el-input
                  v-model="formData.max_age"
                  class="salary-input"
                  placeholder="最大年龄"
                />
              </el-col>
            </div>
          </template>
          <template v-else-if="item.type == 'mapPicker'">
            <TencentMapPicker
              v-model="formData[item.props]"
              class="map-picker"
              :placeholder="item.placeholder"
              :region-name="workCityRegionName"
              :region-codes="workCityRegionCodes"
              @confirmMap="handleConfirmMap"
            />
          </template>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <div style="margin-bottom: 10px; padding-left: 20px">
          <div style="margin-bottom: 6px">职位介绍</div>
          <el-input
            v-model="formData.job_remark"
            type="textarea"
            rows="5"
            placeholder="请输入职位介绍"
            maxlength="200"
            show-word-limit
          >
          </el-input>
        </div>
      </el-col>
    </el-form>
    <div class="btn">
      <el-button
        size="medium"
        type="primary"
        :disabled="loadingStaus"
        @click="saveConfirm"
      >
        保存
      </el-button>
    </div>
    <el-dialog
      v-if="showCreateTaskAction"
      title="新建任务"
      :visible.sync="createTaskDialogVisible"
      width="70%"
      append-to-body
      destroy-on-close
    >
      <CreateTaskContent
        ref="createTaskContent"
        silent-qr-dialog
        :show-create-recruit-action="false"
        @confirm="handleTaskCreated"
      />
    </el-dialog>
  </div>
</template>

<script>
import json from "../../../../public/citys.json";
import { gettreeList, tog_SALARY_TYPE_LIST, SALARY_TYPE_VALUE_MAP } from "@/utils/utils";
import TencentMapPicker from "@/components/TencentMapPicker.vue";
import CreateTaskContent from "@/pages/privateTask/components/CreateTaskContent.vue";

const getDefaultFormData = () => ({
  mission_ids: [],
  renew_type: 1,
  is_sync_alipay: 1,
});

export default {
  name: "CreateEditContent",
  components: { TencentMapPicker, CreateTaskContent },
  props: {
    id: {
      type: [String, Number],
      default: "",
    },
    showCreateTaskAction: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      taskList: [],
      task_id: "",
      formList: [
        {
          required: true,
          label: "岗位名称",
          type: "input",
          props: "recruit_post",
          value: "",
          placeholder: "请输入岗位名称",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "岗位标签",
          type: "cascader",
          props: "tag_ids",
          value: [],
          multiple: true,
          collapseTags: true,
          maxCollapseTags: 2,
          selectOption: [],
          placeholder: "请选择岗位标签",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "行业类型",
          type: "cascader",
          props: "category_ids",
          value: [],
          multiple: true,
          collapseTags: true,
          maxCollapseTags: 2,
          selectOption: [],
          placeholder: "请选择行业类型",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "用工人数",
          type: "input",
          props: "worked_num",
          value: "",
          placeholder: "请输入用工人数",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "年龄要求",
          props: "min_age",
          disabled: false,
          type: "age",
        },
        {
          required: true,
          label: "学历要求",
          type: "picker",
          props: "minimum_education",
          selectOption: [
            { label: "不限", value: "0" },
            { label: "小学", value: "1" },
            { label: "初中", value: "2" },
            { label: "高中", value: "3" },
            { label: "大专", value: "4" },
            { label: "本科及以上", value: "5" },
          ],
          placeholder: "请选择学历要求",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "工作地点",
          type: "cascader",
          props: "work_city",
          value: "",
          selectOption: json.data,
          valueLevel: "more",
          placeholder: "请选择工作地点",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "详细地点",
          type: "mapPicker",
          props: "address",
          placeholder: "请点击地图选点",
          value: "",
          disabled: false,
          show: true,
        },
        {
          label: "联系人电话",
          type: "input",
          props: "contact_number",
          placeholder: "请输入联系人电话",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "岗位状态",
          type: "picker",
          props: "status",
          placeholder: "请选择岗位状态",
          selectOption: [
            { label: "未开始", value: 0 },
            { label: "进行中", value: 1 },
            { label: "已完成", value: 2 },
            { label: "已暂停", value: 3 },
          ],
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "结算方式",
          type: "picker",
          props: "salary_type",
          selectOption: tog_SALARY_TYPE_LIST,
          placeholder: "请选择结算方式",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "薪资范围",
          type: "salary",
          props: "min_salary",
          placeholder: "请输入薪资",
          value: "",
          show: true,
        },
        {
          required: true,
          label: "工作性质",
          type: "picker",
          props: "work_type",
          placeholder: "请选择工作性质",
          selectOption: [
            { label: "全职", value: 1 },
            { label: "兼职", value: 2 },
            { label: "实习", value: 3 },
          ],
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "岗位时效",
          type: "picker",
          props: "renew_type",
          placeholder: "请选择岗位时效",
          selectOption: [
            { label: "1个月", value: 1 },
            { label: "2个月", value: 2 },
            { label: "3个月", value: 3 },
          ],
          disabled: false,
          show: true,
        },
        {
          required: false,
          label: "同步到支付宝就业",
          type: "picker",
          props: "is_sync_alipay",
          placeholder: "请选择是否同步到支付宝就业",
          selectOption: [
            { label: "否", value: 0 },
            { label: "是", value: 1 },
          ],
          disabled: false,
          show: true,
        },
        {
          required: false,
          label: "绑定任务",
          type: "multiplePicker",
          props: "mission_ids",
          collapseTags: true,
          maxCollapseTags: 1,
          selectOption: [],
          placeholder: "请选择绑定任务",
          value: [],
          disabled: false,
          show: true,
        },
        
      ],
      loadingStaus: false,
      formData: getDefaultFormData(),
      optionsLoaded: false,
      createTaskDialogVisible: false,
    };
  },
  computed: {
    workCityRegionCodes() {
      const w = this.formData.work_city;
      if (!Array.isArray(w) || w.length === 0) return [];
      const isCode = w.every((v) => typeof v === "string" && /^\d{4,6}$/.test(v));
      return isCode ? w : [];
    },
    workCityRegionName() {
      const w = this.formData.work_city;
      if (!Array.isArray(w) || w.length === 0) return "";
      const isCode = w.every((v) => typeof v === "string" && /^\d{4,6}$/.test(v));
      if (isCode) {
        const name = this.getRegionLabelByCodes(json.data, w);
        return name || "";
      }
      return w[w.length - 1] || "";
    },
  },
  watch: {
    id() {
      if (this.optionsLoaded) {
        this.init();
      }
    },
    "formData.min_salary"(val) {
      if (val && !this.formData.salary_type) {
        this.$message.error("请先选择结算方式");
        this.formData.min_salary = "";
      }
    },
    "formData.max_salary"(val) {
      if (val && !this.formData.salary_type) {
        this.$message.error("请先选择结算方式");
        this.formData.max_salary = "";
      }
    },
  },
  methods: {
    openCreateTaskDialog() {
      this.createTaskDialogVisible = true;
    },
    async handleTaskCreated(taskId) {
      await this.getQuickMissionList();
      const missionIds = Array.isArray(this.formData.mission_ids)
        ? [...this.formData.mission_ids]
        : [];
      if (taskId && !missionIds.includes(taskId)) {
        missionIds.push(taskId);
      }
      this.formData.mission_ids = missionIds;
      this.createTaskDialogVisible = false;
      this.$message.success("任务创建成功");
    },
    getRegionLabelByCodes(tree, codes) {
      if (!tree || !codes || !codes.length) return "";
      let list = tree;
      let label = "";
      for (let i = 0; i < codes.length; i++) {
        const node = list.find((n) => n.value === codes[i]);
        if (!node) return label;
        label = node.label || "";
        list = node.children || [];
      }
      return label;
    },
    handleConfirmMap(payload) {
      this.formData.address = payload.address;
      this.formData.lat = payload.lat;
      this.formData.lon = payload.lon;
    },
    resetFormData() {
      this.task_id = "";
      this.formData = getDefaultFormData();
      this.$nextTick(() => {
        this.$refs.companyForm && this.$refs.companyForm.clearValidate();
      });
    },
    async getDailyTaskIndustryList() {
      const res = await this.$api.getDailyTaskIndustryList();
      const options = gettreeList(res, "industry_type_name", "id");
      this.formList.forEach((item) => {
        if (item.props === "category_ids") {
          item.selectOption = options;
        }
      });
    },
    selectTask(e) {
      const currentTask = this.taskList.find((item) => e == item.id);
      if (!currentTask) return;
      this.formData = {
        ...this.formData,
        renew_type: 1,
        is_sync_alipay: 1,
        recruit_post: currentTask.title,
        work_city: [currentTask.province, currentTask.city, currentTask.area],
        minimum_education: "" + currentTask.min_qualification,
        min_salary: currentTask.min_salary,
        max_salary: currentTask.max_salary,
        worked_num: currentTask.person_num,
        address: currentTask.address,
        lat: currentTask.lat,
        lon: currentTask.lon,
        salary_type: SALARY_TYPE_VALUE_MAP[parseInt(currentTask.salary_type)],
      };
    },
    async getQuickMissionList() {
      const res = await this.$api.get_quick_mission_list();
      this.taskList = res || [];
      const options = this.taskList.map((t) => ({
        label: t.title || t.name || t.recruit_post || String(t.id),
        value: t.id,
      }));
      this.formList.forEach((item) => {
        if (item.props === "mission_ids") {
          item.selectOption = options;
        }
      });
    },
    async getDailyPostTagList() {
      const res = await this.$api.getDailyPostTagList();
      const options = gettreeList(res, "name", "id");
      this.formList.forEach((item) => {
        if (item.props === "tag_ids") {
          item.selectOption = options;
        }
      });
    },
    async saveConfirm() {
      this.$refs.companyForm.validate((valid) => {
        if (valid) {
          if (!this.validateSalaryRange()) return;
          this.formSubmit();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
      return true;
    },
    validateSalaryRange() {
      const { min_salary, max_salary, salary_type } = this.formData || {};
      if (!salary_type) {
        this.$message.error("请先选择结算方式");
        return false;
      }
      if (!max_salary) {
        this.$message.error("请输入最高薪资金额");
        return false;
      }
      if (!min_salary) {
        this.$message.error("请输入最低薪资金额");
        return false;
      }
      const minVal = Number(min_salary);
      const maxVal = Number(max_salary);
      if (Number.isNaN(minVal) || Number.isNaN(maxVal)) {
        this.$message.error("薪资范围需为数字");
        return false;
      }
      if (minVal > maxVal) {
        this.$message.error("最低薪资不能高于最高薪资");
        return false;
      }
      const salaryLimits = {
        1: { min: 100, max: 20000 },
        2: { min: 10, max: 500 },
        3: { min: 80, max: 5000 },
        4: { min: 500, max: 20000 },
        5: { min: 2000, max: 100000 },
        6: { min: 1000, max: 500000 },
      };
      const limit = salaryLimits[salary_type];
      if (limit) {
        if (minVal < limit.min) {
          this.$message.error(`最低薪资为${limit.min}元`);
          return false;
        }
        if (maxVal > limit.max) {
          this.$message.error(`超出薪资上限${limit.max}元`);
          return false;
        }
      }
      return true;
    },
    async formSubmit() {
      this.loadingStaus = true;
      try {
        let areaParam = {};
        if (this.formData.work_city && this.formData.work_city[0]) {
          areaParam = {
            province: this.formData.work_city[0],
            city: this.formData.work_city[1],
            area: this.formData.work_city[2],
          };
        }

        const submitData = {
          ...this.formData,
          category_ids: Array.isArray(this.formData.category_ids)
            ? [...this.formData.category_ids]
            : [],
          tag_ids: Array.isArray(this.formData.tag_ids) ? [...this.formData.tag_ids] : [],
        };

        if (Array.isArray(submitData.category_ids[0])) {
          submitData.category_ids = submitData.category_ids.map((item) => item[item.length - 1]);
        }
        if (submitData.tag_ids.length && Array.isArray(submitData.tag_ids[0])) {
          submitData.tag_ids = submitData.tag_ids.map((item) => item[item.length - 1]);
        }

        let res;
        if (this.id) {
          res = await this.$api.recruitTaskUpdate(this.id, {
            ...submitData,
            ...areaParam,
          });
        } else {
          res = await this.$api.recruitTaskAdd({
            ...submitData,
            ...areaParam,
          });
        }

        if (res) {
          this.$notify.success("保存成功！");
          this.$emit("confirm", res);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingStaus = false;
      }
    },
    async init() {
      this.resetFormData();
      if (this.id) {
        const data = await this.$api.recruitTaskDetail({ id: this.id });
        this.formData = {
          ...data,
          tag_ids: data.recruit_post_tag_ids || [],
          category_ids: data.recruit_post_category_ids || [],
          work_city: [data.province, data.city, data.area],
          minimum_education: data.minimum_education + "",
          renew_type: data.renew_type || 1,
          is_sync_alipay:
            data.is_sync_alipay === undefined || data.is_sync_alipay === null
              ? 1
              : data.is_sync_alipay,
          mission_ids: Array.isArray(data.mission_ids) ? data.mission_ids : [],
        };
      }
    },
    async loadBaseData() {
      this.loadingStaus = true;
      try {
        await Promise.all([
          this.getQuickMissionList(),
          this.getDailyTaskIndustryList(),
          this.getDailyPostTagList(),
        ]);
        this.optionsLoaded = true;
        await this.init();
      } finally {
        this.loadingStaus = false;
      }
    },
  },
  mounted() {
    this.loadBaseData();
  },
};
</script>

<style lang="scss" scoped>
.el-icon-warning {
  margin: 5px 0 0 4px;
  color: #409eff;
  font-size: 18px;
}

.text-center {
  text-align: center;
}

.form-content {
  display: flex;
  flex-flow: column nowrap;

  .multiple-picker-wrap {
    display: flex;
    align-items: center;
  }

  .multiple-picker-wrap--with-action {
    gap: 8px;
  }

  .select,
  .input,
  .cascader {
    width: 240px;
  }

  .mission-create-btn {
    flex-shrink: 0;
  }

  .map-picker {
    width: 240px;
  }

  .salary-input {
    width: 100%;
  }

  .btn {
    display: flex;
    justify-content: center;
  }
}

.quick-create-btn {
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-start;
}
</style>
